import { combineReducers } from 'redux';

import flags from './flags';

export default combineReducers({
  flags,
});
